/* eslint-disable react/jsx-no-undef */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import {
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Drawer,
  TextField,
  FormControl,
  Radio,
  RadioGroup,
  Select,
  MenuItem,
  SelectChangeEvent,
  Slider,
  InputBase,
  Box,
  ListItemText,
} from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useLocation } from "react-router-dom";
import dayjs, { Dayjs } from "dayjs";
interface FilterMenuProps {
  tabIndex?: number;
  startDate: Dayjs | null;
  endDate: Dayjs | null;
  setStartDate: (date: Dayjs | null) => void;
  setEndDate: (date: Dayjs | null) => void;
  handleSubmit?: (clearData?: any) => void;
}
function valueText(value: number) {
  return `${value}°C`;
}
function FilterMenu({ tabIndex, startDate, endDate, setStartDate, setEndDate, handleSubmit }: FilterMenuProps) {
  const [openDrawer, setOpenDrawer] = useState(false);
  const location = useLocation();
  const currentPath = location.pathname;

  const isUserManagementPage = currentPath === "/manage-customers";
  const isTransactionPage = currentPath === "/transactions";
  const isAnalyticsPage = currentPath === "/revenue-analytics";
  const isMemberReportsTab = tabIndex === 0;
  const isBookingReportsTab = tabIndex === 1;
  const isCancellationReportsTab = tabIndex === 2;
  const [paidOption, setPaidOption] = useState("");
  const toggleDrawer = (open: boolean) => () => {
    setOpenDrawer(open);
  };
  const [value, setValue] = React.useState({
    page: "0",
    type: "0",
  });

  const handleChange1 = (event: SelectChangeEvent) => {
    const { name, value } = event.target;
    setValue((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const [value1, setValue1] = React.useState<number[]>([20, 37]);

  const handleChange = (event: Event, newValue: number | number[]) => {
    setValue1(newValue as number[]);
  };
  const [selectedGroups, setSelectedGroups] = useState<string[]>([]);
  const groupOptions = [
    { label: "Field 1", value: "10" },
    { label: "Field 2", value: "20" },
    { label: "Field 3", value: "30" },
    { label: "Field 4", value: "40" },
  ];
  const [searchTerm, setSearchTerm] = useState("");
  const filteredOptions = groupOptions.filter((option) =>
    option.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleGroupChange = (event: any) => {
    const {
      target: { value },
    } = event;
    setSelectedGroups(typeof value === "string" ? value.split(",") : value);
  };
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };

  const handleClearAll = () => {
    setStartDate(null)
    setEndDate(null)
    setOpenDrawer(false)
    handleSubmit?.(true)
  }

  return (
    <>
      <Button onClick={toggleDrawer(true)} className="btn btn_primary">
        <img src="/static/images/filter_icon.svg" alt="icon" /> Filters
      </Button>

      <Drawer
        anchor="right"
        open={openDrawer}
        onClose={toggleDrawer(false)}
        className="filter_drawer"
      >
        <div style={{ width: 420, padding: 20 }} className="filter_body">
          <div
            className="filter_head"
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: 20,
            }}
          >
            <h3>Filters</h3>
            <a onClick={handleClearAll} style={{ cursor: "pointer" }}>
              Clear All
            </a>
          </div>

          <div className="gap_m">
            {isTransactionPage ? (
              // Show only Date Range for transactions
              <>
                <div className="w_50 control_group">
                  <label>Select Start Range</label>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      className="form_control"
                      slots={{
                        openPickerIcon: () => (
                          <img
                            src="/static/images/calendar_icon.svg"
                            alt="icon"
                          />
                        ),
                        textField: (params) => (
                          <TextField
                            {...params}
                            fullWidth
                            placeholder="Date"
                            hiddenLabel
                          />
                        ),
                      }}
                      desktopModeMediaQuery="(min-width:0px)"
                    />
                  </LocalizationProvider>
                </div>

                <div className="w_50 control_group">
                  <label>Select End Range</label>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      className="form_control"
                      slots={{
                        openPickerIcon: () => (
                          <img
                            src="/static/images/calendar_icon.svg"
                            alt="icon"
                          />
                        ),
                        textField: (params) => (
                          <TextField
                            {...params}
                            fullWidth
                            placeholder="Date"
                            hiddenLabel
                          />
                        ),
                      }}
                      desktopModeMediaQuery="(min-width:0px)"
                    />
                  </LocalizationProvider>
                </div>
              </>
            ) : isMemberReportsTab ?
              (
                <>
                  <div className="w_50 control_group date_field">
                    <label>Start Date</label>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        className="form_control"
                        format="DD/MM/YYYY"

                        value={startDate}
                        slotProps={{
                          textField: {
                            placeholder: "Start Date",
                            sx: {
                              "& .MuiInputBase-input.Mui-disabled": {
                                WebkitTextFillColor: "#9999", // change text & placeholder color
                                opacity: 1,
                              },
                            },
                          },
                        }}
                        onChange={(newValue) => setStartDate?.(newValue)}
                        slots={{
                          openPickerIcon: () => (
                            <img
                              src="/static/images/calendar_icon.svg"
                              alt="icon"
                            />
                          ),
                          // textField: (params) => (
                          //   <TextField
                          //     {...params}
                          //     fullWidth
                          //     placeholder="Start Date"
                          //     hiddenLabel
                          //   />
                          // ),
                        }}
                        desktopModeMediaQuery="(min-width:0px)"
                      />
                    </LocalizationProvider>
                  </div>
                  <div className="w_50 control_group date_field">
                    <label>End Date</label>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        className="form_control"
                        value={endDate}
                        onChange={(newValue) =>
                          setEndDate?.(newValue)
                        }
                        minDate={dayjs(startDate)}
                        format="DD/MM/YYYY"
                        slotProps={{
                          textField: {
                            placeholder: "End Date",
                            sx: {
                              "& .MuiInputBase-input.Mui-disabled": {
                                WebkitTextFillColor: "#9999", // change text & placeholder color
                                opacity: 1,
                              },
                            },
                          },
                        }}
                        slots={{
                          openPickerIcon: () => (
                            <img
                              src="/static/images/calendar_icon.svg"
                              alt="icon"
                            />
                          ),

                        }}
                        desktopModeMediaQuery="(min-width:0px)"
                        disabled={!startDate}
                      />
                    </LocalizationProvider>
                  </div>
                  <div className="control_group ">
                    <FormControl className="paid_radio">
                      <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        defaultValue="female"
                        name="radio-buttons-group"
                        value={paidOption}
                        onChange={(e) =>
                          setPaidOption(e.target.value)
                        }
                      >
                        <FormControlLabel
                          value="Active Members (Last 30 Days)"
                          control={<Radio />}
                          label="Active Members (Last 30 Days)"
                        />
                        <FormControlLabel
                          value="Inactive Members"
                          control={<Radio />}
                          label="Inactive Members"
                        />
                        <FormControlLabel
                          value="Trial Members"
                          control={<Radio />}
                          label="Trial Members"
                        />
                        <FormControlLabel
                          value="Expiring Memberships"
                          control={<Radio />}
                          label="Expiring Memberships"
                        />
                        <FormControlLabel
                          value="New Member Signups"
                          control={<Radio />}
                          label="New Member Signups"
                        />
                      </RadioGroup>
                    </FormControl>
                  </div>

                </>
              ) : isBookingReportsTab ? (
                <>
                  <div className="w_50 control_group">
                    <label>Start Date</label>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        className="form_control"
                        slots={{
                          openPickerIcon: () => (
                            <img
                              src="/static/images/calendar_icon.svg"
                              alt="icon"
                            />
                          ),
                          textField: (params) => (
                            <TextField
                              {...params}
                              fullWidth
                              placeholder="Date"
                              hiddenLabel
                            />
                          ),
                        }}
                        desktopModeMediaQuery="(min-width:0px)"
                      />
                    </LocalizationProvider>
                  </div>
                  <div className="w_50 control_group">
                    <label>End Date</label>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        className="form_control"
                        slots={{
                          openPickerIcon: () => (
                            <img
                              src="/static/images/calendar_icon.svg"
                              alt="icon"
                            />
                          ),
                          textField: (params) => (
                            <TextField
                              {...params}
                              fullWidth
                              placeholder="Date"
                              hiddenLabel
                            />
                          ),
                        }}
                        desktopModeMediaQuery="(min-width:0px)"
                      />
                    </LocalizationProvider>
                  </div>
                  <div className="control_group ">
                    <FormControl className="paid_radio">
                      <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        defaultValue="female"
                        name="radio-buttons-group"
                        value={paidOption}
                        onChange={(e) =>
                          setPaidOption(e.target.value)
                        }
                      >

                        <FormControlLabel
                          value="Bookings By Date Range"
                          control={<Radio />}
                          label="Bookings By Date Range"
                        />
                        <FormControlLabel
                          value="Top Performing Offers"
                          control={<Radio />}
                          label="Top Performing Offers"
                        />
                      </RadioGroup>
                    </FormControl>
                  </div>
                </>
              ) : (
                // Full filter form
                <>
                  <FormGroup className="text_checkbox">
                    <label className="w_100">Membership Type</label>
                    <FormControlLabel control={<Checkbox />} label="Single" />
                    <FormControlLabel control={<Checkbox />} label="Duo" />
                  </FormGroup>

                  <FormGroup className="text_checkbox">
                    <label className="w_100">Status</label>
                    <FormControlLabel control={<Checkbox />} label="Trial" />
                    <FormControlLabel control={<Checkbox />} label="Paid" />
                    <FormControlLabel
                      control={<Checkbox />}
                      label="Complementary"
                    />
                  </FormGroup>
                  <div className="control_group w_50">
                    <label>Select Gender</label>
                    <Select
                      className="dropse"
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      inputProps={{
                        "aria-label": "Without label",
                      }}
                      displayEmpty
                      name="type"
                      value={value.type}
                      onChange={handleChange1}
                    >
                      <MenuItem value="0" disabled>
                        Select Gender
                      </MenuItem>

                      <MenuItem value="10"> Male</MenuItem>
                      <MenuItem value="20">Female</MenuItem>
                      <MenuItem value="30">Both</MenuItem>
                    </Select>
                  </div>
                  <div className="control_group w_100">
                    <label>Select Age Range</label>
                    <Slider
                      getAriaLabel={() => 'Temperature range'}
                      value={value1}
                      onChange={handleChange}
                      valueLabelDisplay="auto"
                      getAriaValueText={valueText}
                    />
                  </div>

                  <div className="w_100 control_group">
                    <label>Created Date</label>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        className="form_control"
                        slots={{
                          openPickerIcon: () => (
                            <img
                              src="/static/images/calendar_icon.svg"
                              alt="icon"
                            />
                          ),
                          textField: (params) => (
                            <TextField
                              {...params}
                              fullWidth
                              placeholder="Date"
                              hiddenLabel
                            />
                          ),
                        }}
                        desktopModeMediaQuery="(min-width:0px)"
                      />
                    </LocalizationProvider>
                  </div>

                  <div className="w_100 control_group">
                    <label>Expiry Date</label>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        className="form_control"
                        slots={{
                          openPickerIcon: () => (
                            <img
                              src="/static/images/calendar_icon.svg"
                              alt="icon"
                            />
                          ),
                          textField: (params) => (
                            <TextField
                              {...params}
                              fullWidth
                              placeholder="Date"
                              hiddenLabel
                            />
                          ),
                        }}
                        desktopModeMediaQuery="(min-width:0px)"
                      />
                    </LocalizationProvider>
                  </div>

                  <div className="w_50 control_group">
                    <label>Select Start Range</label>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        className="form_control"
                        slots={{
                          openPickerIcon: () => (
                            <img
                              src="/static/images/calendar_icon.svg"
                              alt="icon"
                            />
                          ),
                          textField: (params) => (
                            <TextField
                              {...params}
                              fullWidth
                              placeholder="Date"
                              hiddenLabel
                            />
                          ),
                        }}
                        desktopModeMediaQuery="(min-width:0px)"
                      />
                    </LocalizationProvider>
                  </div>

                  <div className="w_50 control_group">
                    <label>Select End Range</label>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        className="form_control"
                        slots={{
                          openPickerIcon: () => (
                            <img
                              src="/static/images/calendar_icon.svg"
                              alt="icon"
                            />
                          ),
                          textField: (params) => (
                            <TextField
                              {...params}
                              fullWidth
                              placeholder="Date"
                              hiddenLabel
                            />
                          ),
                        }}
                        desktopModeMediaQuery="(min-width:0px)"
                      />
                    </LocalizationProvider>
                  </div>
                  <div className="control_group w_100">
                    <Select
                      multiple
                      displayEmpty
                      className="dropse"
                      value={selectedGroups}
                      onChange={handleGroupChange}
                      input={<InputBase />}
                      renderValue={(selected) => {
                        if (selected.length === 0) return <span>Select Expertise</span>;
                        return groupOptions
                          .filter((opt) => selected.includes(opt.value))
                          .map((opt) => opt.label)
                          .join(", ");
                      }}
                      MenuProps={{
                        PaperProps: { style: { maxHeight: 300, padding: 0 } },
                      }}
                    >
                      <Box px={2} pt={1} pb={1}>
                        <TextField
                          fullWidth
                          placeholder="Search..."
                          value={searchTerm}
                          onChange={handleSearchChange}
                          variant="standard"
                          autoFocus
                        />
                      </Box>

                      {filteredOptions.map((option) => (
                        <MenuItem
                          key={option.value}
                          value={option.value}
                          className="multi_check_select"
                        >
                          <Checkbox checked={selectedGroups.includes(option.value)} />
                          <ListItemText primary={option.label} />
                        </MenuItem>
                      ))}
                    </Select>
                  </div>
                  <div className="control_group w_100">
                    <Select
                      multiple
                      displayEmpty
                      className="dropse"
                      value={selectedGroups}
                      onChange={handleGroupChange}
                      input={<InputBase />}
                      renderValue={(selected) => {
                        if (selected.length === 0) return <span>Select Interests</span>;
                        return groupOptions
                          .filter((opt) => selected.includes(opt.value))
                          .map((opt) => opt.label)
                          .join(", ");
                      }}
                      MenuProps={{
                        PaperProps: { style: { maxHeight: 300, padding: 0 } },
                      }}
                    >
                      <Box px={2} pt={1} pb={1}>
                        <TextField
                          fullWidth
                          placeholder="Search..."
                          value={searchTerm}
                          onChange={handleSearchChange}
                          variant="standard"
                          autoFocus
                        />
                      </Box>

                      {filteredOptions.map((option) => (
                        <MenuItem
                          key={option.value}
                          value={option.value}
                          className="multi_check_select"
                        >
                          <Checkbox checked={selectedGroups.includes(option.value)} />
                          <ListItemText primary={option.label} />
                        </MenuItem>
                      ))}
                    </Select>
                  </div>

                  {isUserManagementPage && (
                    <>
                      <div className="w_100 control_group">
                        <FormControlLabel
                          control={<Checkbox />}
                          label="Logged in Users"
                        />
                      </div>
                      <div className="w_100 control_group">
                        <FormControlLabel
                          control={<Checkbox />}
                          label="Didn't Created Order"
                        />
                      </div>
                    </>
                  )}
                </>
              )}
          </div>

          <div className="btn_flex">
            <Button className="btn btn_primary" onClick={() => {
              if (handleSubmit) {
                handleSubmit();
              }
              setOpenDrawer(false);
            }}>
              Save
            </Button>
          </div>
        </div>
      </Drawer>
    </>
  );
}

export default FilterMenu;
